import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOfferForAnalytic } from '../../utils/tracking/types';

export interface IAnalyticState {
  offerForAnalytics: IOfferForAnalytic | null;
}

export const initialState: IAnalyticState = {
  offerForAnalytics: null,
};

export const analyticSlice = createSlice({
  initialState,
  name: 'analytic',
  reducers: {
    setOfferForAnalytic: (state, { payload: { offerForAnalytics } }: PayloadAction<IAnalyticState>) => {
      state.offerForAnalytics = offerForAnalytics;
    },
  },
});

export const { setOfferForAnalytic } = analyticSlice.actions;
